import { HStack, Spinner, StackProps } from '@chakra-ui/react'

export const PageSpinner = (props: StackProps) => {
  return (
    <HStack width="full" height="100vh" justifyContent="center" {...props}>
      <Spinner />
    </HStack>
  )
}
